import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  StudentAlreadyPausedContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "40px",
  },
  pauseDetailContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "24px",
  },
  pauseHeading: {
    fontSize: "20px",
    fontWeight: 600,
    fontFamily: "Roboto",
    color: "#444444",
    lineHeight: "100%",
    textAlign: "center",
    margin: "0px",
  },
  pauseDescription: {
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#555555",
    lineHeight: "100%",
    textAlign: "center",
    margin: "0px",
  },
  dateRangeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
  },
  dateRange: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "8px 12px",
    borderRadius: "4px",
    backgroundColor: "#F0F0F0",
  },
  dateLabel: {
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#555555",
    lineHeight: "22px",
    margin: "0px",
  },
  dateValue: {
    fontSize: "16px",
    fontWeight: 500,
    fontFamily: "Roboto",
    color: "#555555",
    lineHeight: "22px",
    margin: "0px",
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "298px",
  },
}));
